import { fetchAuthSession } from 'aws-amplify/auth';
import type { AsnMetrics, AsnMetricsService } from '../types';
import { getAwsConfig } from '../../config/appConfig';
import { ensureAmplifyConfigured } from './amplifyConfig';

/**
 * ASN metrics from the service API (GET /v1/asn/metrics). Returns per-
 * integration counts (total / data errors / business errors) for the window,
 * authorized with the signed-in employee's Cognito token.
 */
export const awsAsnMetricsService: AsnMetricsService = {
    async getMetrics(from?: string, to?: string, identityId?: string): Promise<AsnMetrics> {
        ensureAmplifyConfigured();

        const base = getAwsConfig().asnApiEndpoint;
        if (!base) {
            throw new Error('ASN API endpoint is not configured.');
        }

        const session = await fetchAuthSession();
        const token = session.tokens?.idToken?.toString();
        if (!token) {
            throw new Error('Not authenticated.');
        }

        const url = new URL(`${base.replace(/\/$/, '')}/v1/asn/metrics`);
        if (from) url.searchParams.set('from', from);
        if (to) url.searchParams.set('to', to);
        if (identityId) url.searchParams.set('identityId', identityId);

        const res = await fetch(url.toString(), {
            headers: { Authorization: token },
        });
        if (!res.ok) {
            throw new Error(`Failed to load ASN metrics: ${res.status} ${res.statusText}`);
        }
        return (await res.json()) as AsnMetrics;
    },
};

export default awsAsnMetricsService;
